export default __webpack_public_path__ + "static/media/dopes7.cec7f4b6.jfif";